// This PolyfillOpusEncoder is needed for Safari for now, because Safari doesn't
// yet support the AudioEncoder API.
import EventEmitter from 'eventemitter3';
import * as LibAVWebCodecs from 'libavjs-webcodecs-polyfill';
import { Settings } from '../../Settings';
export class PolyfillOpusEncoder {
    emitter;
    libAv;
    audioEncoder;
    timestampFifo = [];
    constructor() {
        this.emitter = new EventEmitter();
    }
    async init() {
        this.libAv = await LibAV.LibAV();
        await LibAVWebCodecs.load({
            polyfill: false,
            LibAV: LibAV,
        });
        this.audioEncoder = new LibAVWebCodecs.AudioEncoder({
            output: (chunk, meta) => {
                const data = new Uint8Array(chunk.byteLength);
                chunk.copyTo(data);
                const description = meta?.decoderConfig.description
                    ? new Uint8Array(meta.decoderConfig.description instanceof ArrayBuffer
                        ? meta.decoderConfig.description
                        : meta.decoderConfig.description.buffer)
                    : undefined;
                this.emitter.emit('audioData', {
                    data: data,
                    timestamp: BigInt(this.popTimestampFromFifo() ?? chunk.timestamp),
                    duration: BigInt(Settings.audioFrameDurationMicroseconds),
                    isKeyFrame: chunk.type === 'key',
                    extradata: description,
                });
            },
            error: (e) => console.error(e),
        });
        this.audioEncoder.configure({
            codec: Settings.audioCodec,
            numberOfChannels: Settings.audioNumberOfChannels,
            sampleRate: Settings.audioSampleRate,
            bitrate: Settings.audioBitrate,
            opus: {
                frameDuration: Settings.audioFrameDurationMicroseconds,
            },
        });
    }
    pushTimestampToFifo(timestamp) {
        this.timestampFifo.push(timestamp);
    }
    popTimestampFromFifo() {
        return this.timestampFifo.shift();
    }
    async encode(timestampMicros, data) {
        this.pushTimestampToFifo(timestampMicros);
        const audioData = new LibAVWebCodecs.AudioData({
            format: 'f32',
            sampleRate: Settings.audioSampleRate,
            numberOfChannels: Settings.audioNumberOfChannels,
            numberOfFrames: data.length / Settings.audioNumberOfChannels,
            timestamp: timestampMicros,
            data: data,
        });
        this.audioEncoder?.encode(audioData);
        audioData.close();
    }
    async stop() {
        await this.audioEncoder?.flush();
        this.audioEncoder?.close();
    }
}
